import {Injectable} from "@angular/core";
import {Apollo} from "apollo-angular";
import {Observable} from "rxjs";
import {map, take} from "rxjs/operators";
import {LoggerService} from "../../common/logger.service";
import {UsanaObject} from "../../usana-object";
import {CheckoutUtil} from "../../../checkout/checkout-util";
import {IProduct, IProductGroup} from "../product-models";
import {GetCartPDP, GetCartProductGroups, GetRecommendedProducts, GetWelcomeKits} from "./gql-cart-product";
import _ from "lodash";

@Injectable({
    providedIn: 'root'
})
export class GqlCartProductService extends UsanaObject {

    constructor(private apollo: Apollo,
                loggerService: LoggerService) {
        super(loggerService);
    }

    getWelcomeKits(): Observable<IProduct[]> {
        return this.apollo
            .watchQuery({
                query: GetWelcomeKits,
                variables: {
                }
            })
            .valueChanges
            .pipe(take(1), map((data: any) => CheckoutUtil.handleApolloResponse(data, (d) => d.data.getWelcomeKits)));
    }

    getRecommendedProducts(productId: number, usanaId: string): Observable<IProduct[]> {
        return this.apollo
            .watchQuery({query: GetRecommendedProducts, variables: {productId, usanaId}})
            .valueChanges
            .pipe(take(1), map((data: any) => CheckoutUtil.handleApolloResponse(data, (d) => d.data.getRecommendedProducts)));
    }

    getCartProductGroups(usanaIds: string[]): Observable<IProductGroup[]> {
        return this.apollo
            .watchQuery({query: GetCartProductGroups, variables: {usanaIds}})
            .valueChanges
            .pipe(take(1), map((data: any) => CheckoutUtil.handleApolloResponse(data, (d) => d.data.getCartProductGroups)));
    }

    getCartPDP(usanaId: string, readableUrl?: string): Observable<IProductGroup> {
        return this.apollo
            .watchQuery({query: GetCartPDP, variables: {usanaId, readableUrl}})
            .valueChanges
            .pipe(take(1), map((data: any) => CheckoutUtil.handleApolloResponse(data, (d) => d.data.getCartPDP)));
    }

    // This gets us back to the structure cart-services uses (using a map)
    // Once we have moved all product group calls to the gateway,
    // we can remove this map and just loop though the array for stuff
    getProductGroupsWithMap(usanaIds: string[]): Observable<IProductGroup[]> {
        return this.getCartProductGroups(usanaIds).pipe(
            map((productGroups: IProductGroup[]) => {
                return productGroups.map(group => {
                    const productsMap = _.reduce(group.products, (result, product: IProduct) => {
                        result[product.id] = product;
                        return result;
                    }, {} as { [key: string]: IProduct });

                    group.products = productsMap;
                    return group;
                });
            })
        );
    }

}
